import { SvgProps } from "./Form";

export const ChatIconFilled = (props: SvgProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.525 13.5005H2.25C1.13025 13.5005 0 12.65 0 10.751V6.97097C0.0157704 5.24759 0.66107 3.58945 1.81438 2.30877C2.96769 1.0281 4.54944 0.213265 6.26175 0.017716C7.22802 -0.0524283 8.19807 0.0862522 9.10598 0.424334C10.0139 0.762415 10.8384 1.29198 11.5234 1.97703C12.2085 2.66208 12.7381 3.48658 13.0761 4.39449C13.4142 5.3024 13.5529 6.27245 13.4827 7.23872C13.2869 8.95173 12.4714 10.534 11.1898 11.6874C9.90826 12.8408 8.2491 13.4856 6.525 13.5005ZM15 6.81047H14.991C14.991 6.98822 14.991 7.16597 14.982 7.34447C14.6925 11.4005 10.9852 14.834 6.813 14.9862V14.9975C7.33845 15.9088 8.09427 16.666 9.00467 17.193C9.91507 17.7201 10.948 17.9986 12 18.0005H15.75C16.3467 18.0005 16.919 17.7634 17.341 17.3415C17.7629 16.9195 18 16.3472 18 15.7505V12.0005C17.9989 10.9483 17.7212 9.9149 17.1946 9.00395C16.6681 8.09301 15.9112 7.33655 15 6.81047Z"
        fill="currentColor"
      />
    </svg>
  );
};
